/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetTransactionListParams,
  TransactionDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Get list of transactions for a customer
 * @summary Get transaction list
 */
export const getTransactionList = (
    branch: string,
    custNo: string,
    params?: GetTransactionListParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TransactionDTO[]>(
      {url: `/api/frontend/transactions/${branch}/${custNo}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetTransactionListInfiniteQueryKey = (branch?: string,
    custNo?: string,
    params?: GetTransactionListParams,) => {
    return [
    'infinite', `/api/frontend/transactions/${branch}/${custNo}`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetTransactionListQueryKey = (branch?: string,
    custNo?: string,
    params?: GetTransactionListParams,) => {
    return [
    `/api/frontend/transactions/${branch}/${custNo}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTransactionListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getTransactionList>>>, TError = unknown>(branch: string,
    custNo: string,
    params?: GetTransactionListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransactionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTransactionListInfiniteQueryKey(branch,custNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransactionList>>> = ({ signal }) => getTransactionList(branch,custNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransactionList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTransactionListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getTransactionList>>>
export type GetTransactionListInfiniteQueryError = unknown


export function useGetTransactionListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTransactionList>>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: undefined |  GetTransactionListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransactionList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionList>>,
          TError,
          Awaited<ReturnType<typeof getTransactionList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTransactionListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTransactionList>>>, TError = unknown>(
 branch: string,
    custNo: string,
    params?: GetTransactionListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransactionList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionList>>,
          TError,
          Awaited<ReturnType<typeof getTransactionList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTransactionListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTransactionList>>>, TError = unknown>(
 branch: string,
    custNo: string,
    params?: GetTransactionListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransactionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get transaction list
 */

export function useGetTransactionListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getTransactionList>>>, TError = unknown>(
 branch: string,
    custNo: string,
    params?: GetTransactionListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getTransactionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTransactionListInfiniteQueryOptions(branch,custNo,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetTransactionListQueryOptions = <TData = Awaited<ReturnType<typeof getTransactionList>>, TError = unknown>(branch: string,
    custNo: string,
    params?: GetTransactionListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTransactionListQueryKey(branch,custNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTransactionList>>> = ({ signal }) => getTransactionList(branch,custNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTransactionList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTransactionListQueryResult = NonNullable<Awaited<ReturnType<typeof getTransactionList>>>
export type GetTransactionListQueryError = unknown


export function useGetTransactionList<TData = Awaited<ReturnType<typeof getTransactionList>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: undefined |  GetTransactionListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionList>>,
          TError,
          Awaited<ReturnType<typeof getTransactionList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTransactionList<TData = Awaited<ReturnType<typeof getTransactionList>>, TError = unknown>(
 branch: string,
    custNo: string,
    params?: GetTransactionListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTransactionList>>,
          TError,
          Awaited<ReturnType<typeof getTransactionList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTransactionList<TData = Awaited<ReturnType<typeof getTransactionList>>, TError = unknown>(
 branch: string,
    custNo: string,
    params?: GetTransactionListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get transaction list
 */

export function useGetTransactionList<TData = Awaited<ReturnType<typeof getTransactionList>>, TError = unknown>(
 branch: string,
    custNo: string,
    params?: GetTransactionListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTransactionList>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTransactionListQueryOptions(branch,custNo,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




